export const Logo = require('./logo.png');
export const Taxi = require('./taxi.png');
export const Reporte = require('./analitica.png');
export const CashBox = require('./cashier.png');
export const Increment = require('./increment.png');
export const Person = require('./person.png');
